import { GraphNode } from '../graph-node.js';
/**
 * Entry point of a custom function. Parameter values are injected into `.data`
 * by CallFunctionNode before triggering the exec out port.
 */
export class FunctionEntryNode extends GraphNode {
    run() {
        // Values are already written into this.data by the caller; only forward exec.
        this.triggerOutPort('exec');
    }
}
